import { render, staticRenderFns } from "./document-upload-preview.vue?vue&type=template&id=058d3d58&scoped=true"
import script from "./document-upload-preview.vue?vue&type=script&lang=js"
export * from "./document-upload-preview.vue?vue&type=script&lang=js"
import style0 from "./document-upload-preview.vue?vue&type=style&index=0&id=058d3d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d3d58",
  null
  
)

export default component.exports